<div class="organisation-admins-tab" data-testid="organisation-admins-tab">
    @if (!isActive) {
        <div class="alert alert-info" role="status" data-testid="organisation-admins-inactive">
            This organisation is {{ organisation?.deletedAt ? 'deleted' : 'deactivated' }}. Organisation admins cannot be viewed or changed.
        </div>
    } @else if (loading) {
        <spinner></spinner>
    } @else {
        @if (loadError) {
            <div class="alert alert-warning" role="alert" data-testid="organisation-admins-error">{{ loadError }}</div>
        } @else if (rows.length === 0) {
            <p class="text-muted" data-testid="organisation-admins-empty">No organisation admins linked</p>
        } @else {
            <div class="table-responsive">
                <table class="table table-sm align-middle" data-testid="organisation-admins-table">
                    <caption class="visually-hidden">Admins of this organisation</caption>
                    <thead>
                        <tr>
                            <th scope="col">First name</th>
                            <th scope="col">Last name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Added on</th>
                            @if (canWrite) {
                                <th scope="col">Actions</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (row of rows; track row.id) {
                            <tr data-testid="organisation-admin-row">
                                <td>{{ row.firstName }}</td>
                                <td>{{ row.lastName }}</td>
                                <td>{{ row.email }}</td>
                                <td>{{ row.addedOn | date: 'dd/MM/yyyy HH:mm' }}</td>
                                @if (canWrite) {
                                    <td>
                                        <button type="button" class="btn btn-link link-danger p-0 align-baseline"
                                                [attr.aria-label]="'Unlink ' + adminName(row)"
                                                [disabled]="removing"
                                                confirmHeader="Confirm the action"
                                                confirmModal="Are you sure you want to unlink the selected admin from this organisation?"
                                                [confirmMessage]="adminName(row)"
                                                confirmOk="Yes, proceed"
                                                confirmCancel="No, cancel"
                                                confirmOkClass="btn-outline-danger"
                                                confirmCancelClass="btn-gray text-dark"
                                                [confirmCancelFirst]="true"
                                                (confirmedClick)="unlink(row)"
                                                data-testid="organisation-admin-unlink">
                                            <i class="bi bi-x-lg" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
        @if (canWrite) {
            <div class="organisation-admins-actions">
                <button type="button" class="btn btn-success" #linkButton
                        [disabled]="removing"
                        (click)="openLinkModal()"
                        data-testid="organisation-admins-link">
                    <i class="bi bi-link-45deg me-2" aria-hidden="true"></i>Link organisation admins
                </button>
            </div>
        }
    }
</div>
